import styled from 'styled-components'

export const TransactionModalContainer = styled.div`
  display: flex;
  justify-content: 'center';
  align-items: 'center';
  width: 100%;
  height: 100vh;
`

export const TransactionPaymentContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TransactionModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TransactionModalItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TransactionModalItem = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
`

export const ItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TransactionItem = styled.div`
  width: 48%;
`
export const TransactionAmountItem = styled.div`
  width: 90%;
`

export const TransactionPaymentItem = styled.div`
  margin: 5px 0px;
`
